module.exports = __webpack_public_path__ + "img/circle-green-arrow.2d0c67a.png";